<template>
  <div v-if="this.attachments.length > 0 && this.$props.attTypeId == 0" class="mt-1 mb-1 border-solid border-1 surface-border"></div>
  <div v-if="this.attachments.length > 0" class="pt-1 pb-1 flex flex-wrap gap-1 mr-1">
    <div
        v-for="att in this.attachments"
        :key="att.id"
        class="shadow-2 p-1 flex surface-card w-15rem"
        style="border-radius: 6px"
    >
      <div class="w-10">
        <div v-if=" this.$props.attTypeId == 0" class="text-800 text-base font-medium mb-1">
          {{ att.type.name }}
        </div>

        <div v-if="att.thumbnail" class="thumbnail-container flex align-items-center justify-content-center
              h-10rem border-solid border-1 surface-border border-round-sm">
          <img
              :src="thumbnailUrl(att)"
              alt="Thumbnail"
              class="w-full h-full border-round-sm cursor-pointer"
              @click="openModal(att)"
          />
        </div>
        <div
          class="w-full h-10rem flex align-items-center justify-content-center
                border-solid border-1 surface-border border-round-sm"
          v-else
        >
          <i class="pi pi-ban text-6xl font-light text-500"></i>
        </div>
        <div class="text-500 text-sm font-medium overflow-hidden text-overflow-ellipsis">
          {{ att.name + "." + att.fileExt }}
        </div>
        <div class="text-400 text-xs">{{ formattedFileSize(att.size) }}</div>
      </div>
      <div class="download w-2 align-items-center justify-content-center flex">
        <a :href="this.store.basicUrlDownloadLink + att.id + '?internal=' + this.$props.internal">
          <PrimevueButton icon="pi pi-download" severity="secondary" aria-label="Download" />
        </a>
      </div>
    </div>

    <!-- Modal Window -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <img :src="modalImage" alt="Full Image" class="modal-image" />
        <button class="modal-close-btn" @click="closeModal">X</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Security from "./security";
import { store } from "./store";
import Utils from "@/components/utils";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";

export default {
  name: "AttachmentList",
  components: {
    PrimevueButton,
  },
  props: {
    messageId: String,
    internal: Boolean,
    attTypeId: Number,
  },
  data() {
    return {
      store,
      attachments: [],
      showModal: false, // Modal visibility state
      modalImage: "",   // Selected image URL for modal
    };
  },
  computed: {
    Utils() {
      return Utils;
    },
  },
  methods: {
    formattedFileSize(fileSize: number): string {
      return Math.round(fileSize / Math.pow(1024, 1)) + " KB";
    },

    thumbnailUrl(att: any): string {
      return store.Api_url + "/thumbnail/" + att.id+"?internal=" + this.$props.internal;
    },

    openModal(att: any) {
      this.modalImage = this.thumbnailUrl(att);
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.modalImage = "";
    },
  },
  beforeMount() {
    Security.requireToken();
    store.selectModul = this.$route.path.split("/")[1];

    let table = "message_att";
    if (this.$props.internal) {
      table = "message_int_att";
    }
     

    let query = "message_id:"+this.$props.messageId;
    if (this.$props.attTypeId > 0) {
      query = "order_id:"+this.$props.messageId + ",type_id:"+String(this.$props.attTypeId);
    }

    fetch(
        `${store.Api_url}/v1/${table}?query=${query}`,
        Security.requestOptions("GET")
    )
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData.error) {
            notie.alert({
              type: "error",
              text: "Nepodarilo sa načítať zoznam príloh",
              position: "bottom",
            });
          } else {
            if (responseData.data != null) {
              this.attachments = responseData.data;
            } else {
              this.attachments = [];
            }
          }
        });
  },
};
</script>
<style>
/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  background: white;
  padding: 1rem;
  border-radius: 8px;
  max-width: 90vw;
  max-height: 90vh;
}

.modal-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.modal-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #ff5f5f;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 5px;
  font-size: 1.2rem;
}

.cursor-pointer {
  cursor: pointer;
}
</style>